    import React, { useEffect, useState } from 'react';
import './Detail.css'
import { useNavigate, useParams } from 'react-router-dom';
import { ENDPOINTS, load, store } from '../../global/API';
import { defPermission } from '../../global/Constants';


const PermissionDetail = () => {    
       
    const { id } = useParams()
    const navigate = useNavigate()
    
    const [title, setTitle] = useState('')
    const [data, setData] = useState({...defPermission});
    
    useEffect(() => {
        if (id !== undefined) {
            load(ENDPOINTS.PERMISSION, [id])
            .then(data => {
                const d = data.pop()
                if (d !== undefined) {                
                    setData(d)
                }          
            })
            .catch(err => console.log(err))
        }
    }, [])

    
    useEffect(() => {
        if (id === undefined) {
            setTitle('Nové oprávnění')
        } else {
            setTitle(`Oprávnění: ${id}`)
        }
    }, [data])

    const storeDate = () => {

        store(ENDPOINTS.PERMISSION, [data])
            .then(data => { navigate("/management/permissions/") })
            .catch(err => console.log(err))
    }

    const handleChange = (e) => {
        const {name, value} = e.target

        setData({...data, [name]: value})
    }

    return (
        <div className='detail'>
            <h2>{title}</h2>
            <div className='detail-body'>
                <label>Oprávnění</label>
                <input type='text' name='permission' value={data.permission} onChange={handleChange} />
            </div>
            <div className='detail-submit'>
                <a href="/management/permissions/">Zahodit změny</a>
                <button onClick={() => storeDate()}>
                    {id === undefined ? 'Vytvořit' : 'Potvrdit změny'}
                </button>
            </div>
        </div>
    )
}

export default PermissionDetail